/**
 * プリセット一覧ページ（Presentation）
 */
import type { FC } from "react";
import { Link } from "react-router-dom";
import type { Preset } from "../../../hooks/use-preset-api";
import { PresetsTable } from "./PresetsTable";

type PresetsPageProps = {
  presets: Preset[];
  loading: boolean;
  error: { message: string } | null;
  onToggleActive: (presetId: string) => Promise<void>;
  onDelete: (presetId: string) => Promise<void>;
  isToggling: boolean;
  isDeleting: boolean;
};

/**
 * プリセット管理ページ
 * @param {PresetsPageProps} props コンポーネントProps
 * @return {JSX.Element} ページ要素
 */
export const PresetsPage: FC<PresetsPageProps> = ({
  presets,
  loading,
  error,
  onToggleActive,
  onDelete,
  isToggling,
  isDeleting,
}) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold">プリセット管理</h1>
          <p className="text-base-content/60 mt-1">
            マッチングプリセット（人材/案件プロファイル）を管理できます
          </p>
        </div>
        <Link to="/settings/presets/new" className="btn btn-primary btn-sm">
          + 新規作成
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center py-8">
          <span className="loading loading-spinner loading-lg" />
        </div>
      ) : error ? (
        <div className="alert alert-error">
          <span>{error.message}</span>
        </div>
      ) : (
        <PresetsTable
          presets={presets}
          onToggleActive={onToggleActive}
          onDelete={onDelete}
          isToggling={isToggling}
          isDeleting={isDeleting}
        />
      )}
    </div>
  );
};
